import React from "react";

const NotificationListLoadable = React.lazy(() => import("./NotificationList"));

export { NotificationListLoadable };